/**
 * Whether a tenant agent instance can start or continue runs.
 */

import type { AiStudioAgentInstance } from '@/types/aiStudioAgent';

/** Active status and setup complete (when the API reports setup_configured). */
export function isInstanceRunnable(
  instance: Pick<AiStudioAgentInstance, 'status' | 'setupConfigured'>
): boolean {
  return instance.status === 'active' && instance.setupConfigured !== false;
}

/** Instance can be opened for setup/provision editing (not archived). */
export function isInstanceSetupEditable(instance: Pick<AiStudioAgentInstance, 'status'>): boolean {
  return instance.status !== 'archived';
}
